<template>
  <div class="ph-info">
    <input
      @input="setPhoneLocal"
      @focus="setLastSelectedPhone(index)"
      v-model="phoneLocal"
      type="tel"
      name="ph-1"
      placeholder="770-441-6361"
      maxlength="12"
      @click.stop
    />
    <ul
      class="ph-types"
      :class="{ open: viewListItem }"
      @click.stop.prevent="toggleViewList"
    >
      <!-- Selected Item -->
      <li :key="allPhoneTypes[phoneType[index]]">
        <a
          href="#"
          @click.prevent="setPhoneTypeLocal('orig', phoneType[index])"
          >{{ allPhoneTypes[phoneType[index]].toUpperCase() }}</a
        >

        <a href="#" class="ph-types-drop">
          <img src="../../../assets/img/drop.png" alt="Dropdown" />
        </a>
      </li>

      <!-- Remaining items -->
      <li
        v-for="(currPhoneType, index) in filteredPhoneTypes"
        :key="currPhoneType"
        :class="{ 'show-list-view': viewListItem }"
      >
        <a href="#" @click.stop.prevent="setPhoneTypeLocal('new', index)">
          {{ currPhoneType.toUpperCase() }}
        </a>
      </li>
    </ul>

    <a href="#" class="ph-delete" @click.stop.prevent="removePhone(index)">
      <img src="../../../assets/img/m_trash.png" alt="Delete" />
    </a>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  props: {
    index: Number,
    setLastSelectedPhone: Function,
    closeRemainingPhoneTypeOptions: Boolean,
    closeRemaining: Function
  },
  data() {
    return {
      phoneLocal: "",
      viewListItem: false,
      preventClose: false
    };
  },
  computed: {
    ...mapGetters("addNew", {
      phone: "getPhone",
      phoneType: "getPhoneType",
      allPhoneTypes: "getAllPhoneTypes"
    }),
    filteredPhoneTypes() {
      return this.allPhoneTypes.filter((phoneType, index) => {
        return index !== this.phoneType[this.index];
      });
    },
    currPhoneOfIndex() {
      return this.phone[this.index];
    }
  },
  methods: {
    ...mapMutations("addNew", {
      setPhone: "setPhone",
      setPhoneType: "setPhoneType",
      removePhone: "removePhone"
    }),
    setPhoneLocal() {
      setTimeout(() => {
        const nums = this.phoneLocal.split("");
        let newNums = "";
        for (let i = 0; i < nums.length; i++) {
          if (!isNaN(nums[i]) && newNums.length < 12) {
            if (i !== 0 || parseInt(nums[i]) !== 0) {
              if (newNums.length === 3 || newNums.length === 7) {
                newNums += "-";
              }
              newNums += nums[i];
            }
          }
        }
        this.phoneLocal = newNums;
        this.setPhone({ value: newNums, index: this.index });
        this.setLastSelectedPhone(this.index);
      });
    },
    setPhoneTypeLocal(type, value) {
      if (value >= this.phoneType[this.index] && type !== "orig") {
        value++;
        this.viewListItem = false;
      }
      this.setPhoneType({ value, index: this.index });
    },
    /**
     * Toggle view list
     */
    toggleViewList() {
      this.viewListItem = !this.viewListItem;
      if (this.viewListItem) {
        this.preventClose = true;
        this.closeRemaining(true);
      }
    }
  },
  watch: {
    currPhoneOfIndex(value) {
      this.phoneLocal = value;
    },
    /**
     * Close the phone type options forcefully
     */
    closeRemainingPhoneTypeOptions(value) {
      if (value && !this.preventClose) {
        this.viewListItem = false;
      }
      this.preventClose = false;
      setTimeout(() => {
        this.closeRemaining(false);
      });
    }
  },
  created() {
    this.phoneLocal = this.phone[this.index];
  }
};
</script>

<style scoped>
.show-list-view {
  display: list-item !important;
}
</style>
